var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plantBox"},[_c('div',{ref:"saleEchart",staticStyle:{"width":"100%","height":"100%"}}),(_vm.loading)?_c('dv-loading',{staticStyle:{"color":"#fff","position":"absolute"}},[_vm._v("Loading...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }